<template>
    <b-modal title="Configurazione Magazzino" ref="mdlConfigurazioneMagazzino" id="mdlConfigurazioneMagazzino" size="lg" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Codice Azienda</label>
                <b-form-input v-model="jsonData.codiceAzienda"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Codice Magazzino</label>
                <b-form-input v-model="jsonData.codiceMagazzino"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Descrizione Magazzino</label>
                <b-form-input v-model="jsonData.descrizioneMagazzino"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Grado di relazione</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.tipo" class="mb-2 mr-sm-2 mb-sm-0" :options="tipoMagazzinoOptions" :value="''" value-field="value" text-field="text" required></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Telefono</label>
                <b-form-input v-model="jsonData.telefonoMagazzino"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Fax</label>
                <b-form-input v-model="jsonData.faxMagazzino"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Email</label>
                <b-form-input v-model="jsonData.emailMagazzino"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Provincia</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.provinciaMagazzino" class="mb-2 mr-sm-2 mb-sm-0" :options="provinceOptions" :value="''" value-field="sigla" text-field="provincia" @input="onInputProvincia" required></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Comune</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.localitaMagazzino" class="mb-2 mr-sm-2 mb-sm-0" :options="comuniOptions" :value="''" value-field="codiceIstat" text-field="comune" @input="onInputComune" required></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Cap</label>
                <b-form-input v-model="jsonData.capMagazzino"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Indirizzo</label>
                <b-form-input v-model="jsonData.indirizzoMagazzino"></b-form-input>
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button size="md" class="no-text" variant="outline-danger" @click="onClickUndo">Annulla</b-button>
            <b-button @click="onSalva" variant="outline-success">Salva</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import axios from "axios";
export default {
    mixins: [UtilityMixin],
    components: { ModalError },
    data() {
        return {
            title: null,
            pathResource: "/magazzinomagazzini",
            pathResourceProvince: "/province",
            pathResourceComuni: "/comuni/provincia",
            pathResourceComune: "/comuni/istat",
            isReadOnly: false,
            jsonData: {
                codiceAzienda: "",
                codiceMagazzino: "",
                descrizioneMagazzino: "",
                tipo: null,
                telefonoMagazzino: "",
                faxMagazzino: "",
                emailMagazzino: "",
                provinciaMagazzino: null,
                localitaMagazzino: null,
                capMagazzino: "",
                indirizzoMagazzino: "",
            },
            provinceOptions: [],
            comuniOptions: [{ codiceIstat: null, comune: "-Seleziona Comune-" }],
            tipoMagazzinoOptions: [
                { text: "- Selezionare Valore -", value: null },
                { text: "FISICO", value: "FISICO" },
                { text: "VIRTUALE", value: "VIRTUALE" },
            ],
        };
    },
    mounted() {
        let me = this;
        me.loadProvince();
    },
    methods: {
        loadData() {
            let me = this;
            me.loadDataResources(me.pathResource + "/" + me.jsonData.id, null, me.resultResponse, me.resultError);
        },
        resultResponse(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.loadComuni(me.jsonData.provinciaMagazzino);
            me.loadCap(me.jsonData.localitaMagazzino);
        },
        resultError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        show(data, isReadOnly) {
            let me = this;
            me.jsonData = data;
            me.isReadOnly = isReadOnly;
            if (data.id) {
                me.loadData();
            }
            me.$refs.mdlConfigurazioneMagazzino.show();
        },
        onCloseModal() {
            let me = this;
            me.jsonData = {
                id: null,
                codiceAzienda: null,
                pesoImballo: null,
                descrizioneImballo: null,
            };
            me.$emit("onCloseModal");
            me.$refs.mdlConfigurazioneMagazzino.hide();
        },
        onDeleteMagazzino(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di eliminare questo imballo?", {
                    title: "Eliminazione Imballo",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteMagazzino(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteMagazzino(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, null, me.deleteMagazzinoSuccess, me.deleteMagazzinoError);
        },
        deleteMagazzinoSuccess() {
            let me = this;
            me.loadData();
            me.$bvToast.toast("Eliminazione avvenuta con successo", { title: "Successo", variant: "success", solid: true });
        },
        deleteMagazzinoError(response) {
            let me = this;
            me.$emit("imballoArticoloDelete", response);
            me.$bvToast.toast("Errore durante l'eliminazione", { title: "Errore", variant: "danger", solid: true });
        },
        onSalva() {
            let me = this;
            me.saveResource(me.pathResource, me.jsonData, me.resultSaveResponse, me.resultSaveError);
        },
        resultSaveResponse() {
            let me = this;
            me.$emit("afterSave");
            me.$refs.mdlConfigurazioneMagazzino.hide();
        },
        resultSaveError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        onClickUndo() {
            let me = this;
            me.$refs.mdlConfigurazioneMagazzino.hide();
        },
        loadProvince() {
            let me = this;
            me.provinceOptions = [];
            let link = process.env.VUE_APP_PATH_API + me.pathResourceProvince;
            axios
                .get(link)
                .then((response) => {
                    me.provinceOptions = response.data.data;
                    me.provinceOptions.unshift({ sigla: null, provincia: "-Seleziona Provincia-" });
                })
                .catch((error) => {
                    console.log("Il servizio delle province ha datao errore: " + error.response.status);
                });
        },
        loadComuni(sigla) {
            let me = this;
            //  me.comuneOptsions = [];
            let link = process.env.VUE_APP_PATH_API + me.pathResourceComuni + "/" + sigla;
            axios
                .get(link)
                .then((response) => {
                    me.comuniOptions = response.data.data;
                    me.comuniOptions.unshift({ codiceIstat: null, comune: "-Seleziona Comune-" });
                })
                .catch((error) => {
                    console.log("Il servizio delle province ha datao errore: " + error.response);
                });
        },
        loadCap(codiceIstat) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceComune + "/" + codiceIstat;
            if (codiceIstat) {
                axios
                    .get(link)
                    .then((response) => {
                        me.jsonData.capMagazzino = response.data.data.cap;
                    })
                    .catch((error) => {
                        console.log("Il servizio ha datao errore: " + error.response);
                    });
            }
        },
        onInputProvincia(provincia) {
            let me = this;
            me.comuniOptions = [];
            me.loadComuni(provincia);
        },
        onInputComune(value) {
            let me = this;
            me.loadCap(value);
        },
    },
};
</script>
